import * as utils from '../functions/utils';
import communityUser from './communityUser';
import { COMMENT_MESSAGE_CONTENT_TYPE } from '../constants/constants';
import { GIF_LOADING } from '../api/GiphyAPIs';
import forumTopicDetails from './forumTopicDetails';
import { ICommunityUser } from 'redhotpie-shared-lib/interfaces/IUser';

export interface ICommentsItems {
  replies?: any;
  commentId: number;
  commentParentId: number;
  subject: string;
  message: string;
  dateCreated: string | undefined;
  profile: ICommunityUser | null;
  replyCount: number;
  commentCount: number;
  isLiked: boolean;
  likeCount: number;
  isHasMoreReply: boolean;
  pageNumber: number;
  messageContentType: string;
  imageContent: any;
}

class CommentsItems {
  commentId: number;
  commentParentId: number;
  subject: string;
  message: string;
  dateCreated: string | undefined;
  profile: ICommunityUser | null;
  replyCount: number;
  commentCount: number;
  isLiked: boolean;
  likeCount: number;
  isHasMoreReply: boolean;
  pageNumber: number;
  messageContentType: string;
  imageContent: any;

  constructor() {
    this.commentId = 0;
    this.commentParentId = 0;
    this.subject = '';
    this.message = '';
    this.dateCreated = undefined;
    this.profile = new communityUser();
    this.replyCount = 0;
    this.commentCount = 0;
    this.isLiked = false;
    this.likeCount = 0;
    this.isHasMoreReply = false;
    this.pageNumber = -1;
    this.messageContentType = COMMENT_MESSAGE_CONTENT_TYPE.TEXT;
    this.imageContent = {};
  }

  static mappingObject(_obj: any): ICommentsItems {
    const obj = new CommentsItems();
    obj.commentId = _obj.CommentID;
    obj.commentParentId = _obj.CommentParentID;
    obj.subject = _obj.Subject;
    obj.message = _obj.Message;
    obj.dateCreated = _obj.DateCreated || undefined;
    obj.profile = _obj.Profile ? communityUser.mappingUser(_obj.Profile) : null;
    obj.replyCount = _obj.ReplyCount;
    obj.commentCount = _obj.CommentCount;
    obj.isLiked = _obj.IsLiked || false;
    obj.likeCount = _obj.LikeCount;
    obj.messageContentType = _obj.MessageContentType;
    if (_obj.MessageContentType === COMMENT_MESSAGE_CONTENT_TYPE.GIFFY) {
      obj.imageContent.fullUrl = _obj && _obj.GiphyImage ? GIF_LOADING.replace('{id}', _obj.GiphyImage.GiphyImageID) : '';
      obj.imageContent.width = _obj && _obj.GiphyImage ? _obj.GiphyImage.Width : 0;
      obj.imageContent.height = _obj && _obj.GiphyImage ? _obj.GiphyImage.Height : 0;
    }
    if (_obj.MessageContentType === COMMENT_MESSAGE_CONTENT_TYPE.IMAGE) {
      obj.imageContent = _obj && _obj.ImageContent ? forumTopicDetails.mappingObjectImage(_obj.ImageContent) : {};
    }

    return obj;
  }

  static mappingObjects(_data: any): ICommentsItems[] {
    return _data.map((item: any) => this.mappingObject(item));
  }
}

export interface IComments {
  comments: ICommentsItems[];
  totalItems: number;
  totalPages: string;
  size: number;
  page: number;
}

class Comments {
  comments: ICommentsItems[];
  totalItems: number;
  totalPages: string;
  size: number;
  page: number;

  constructor() {
    this.comments = [];
    this.totalItems = 0;
    this.totalPages = '';
    this.size = 0;
    this.page = 0;
  }

  static mappingObject(_obj: any): IComments {
    const obj = new Comments();
    obj.comments = _obj.Comments ? CommentsItems.mappingObjects(_obj.Comments) : [];
    obj.totalItems = _obj.TotalItems;
    obj.totalPages = _obj.TotalPages;
    obj.size = _obj.Size;
    obj.page = _obj.Page;
    return obj;
  }
}

export { Comments, CommentsItems };
